import { useNavigate } from 'react-router-dom';

import {
  ROUTER_PATHS,
  // useCheckPermissionsArray,
} from '@/shared';
import {
  useFetchPutProducto,
} from '@/shared/actions/erp';
import {
  CustomTextField,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import {
  IDataProducto,
} from '@/shared/interfaces';
// import { useUiStore } from '@/store/ui';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
// import { SAVE_RADIUS_PERMISSIONS } from '../../constants';


export interface SaveServiceProfileComponentProps {
  title: string;
  producto?: IDataProducto;
}

type SaveFormData = IDataProducto & {
  service_profile?:string
};

const SaveServiceProfileComponent: React.FC<SaveServiceProfileComponentProps> = ({ title, producto }) => {
  // useCheckPermissionsArray(SAVE_RADIUS_PERMISSIONS);

  const returnUrlServiceProfilePage = ROUTER_PATHS.configuracionRED.serviceProfileNav;
  const navigate = useNavigate();

  ///* form
  const form = useForm<SaveFormData>({
    // resolver: yupResolver(ipv4FormSchema as any),
    defaultValues: {
      estado:true,
      // latitud: "0",
      // longitud: "0",
      // coordenadas: ipv4?.coordenadas ?? '0,0'
    }
  });

  const {
    handleSubmit,
    formState: { errors },
    reset,
  } = form;


  ///* store
  // const setAlert = useUiStore(s => s.setAlert);


  // const watchedZona = form.watch('zona');
  // const watchedCiudad = form.watch('ciudad');
  
  // const {
  //   setLatLng,
  //   setCurrentCoordenadas,
  // } = useMapComponent({
  //   form,
  //   currentCity: watchedCiudad,
  //   distanciaNapKey: 'distancia_aproximada',
  //   coordenadasCliente: ipv4?.nodo_data?.coordenadas ?? '',
  // });

  // const {
  //   data:GruposIpv4Data,
  //   isLoading:isLoadingGruposIpv4
  // } = useFetchIpv4Groups({
  //   page_size:1000
  // },true)

  // const {
  //   data:ContratosOptions,
  //   isLoading:isLoadingContratosOptions
  // } = useFetchContratos({
  //   enabled:true,
  //   params:{
  //     page_size:20
  //   }
  // })



  ///* mutations
  // const createIpv4 = useCreateIpv4({
  //   navigate,
  //   returnUrl: returnUrlServiceProfilePage,
  // });
  const updateProducto = useFetchPutProducto({
    returnUrl: ROUTER_PATHS.configuracionRED.serviceProfileNav,
  });


  useEffect(() => {

    if (!producto) return;

    reset(producto)

  }, [producto])


  ///* handlers
  const onSave = async (data: SaveFormData) => {
    console.log({data})

    ///* update
    if (producto) {
      await updateProducto.mutateAsync({
        id: producto.id_producto!,
        data: {
          service_profile: data.service_profile
        },
      });
      return;
    }

    ///* create
    // await createIpv4.mutateAsync(data);
  };



  return (
    <SingleFormBoxScene
      titlePage={title}
      onCancel={() => navigate(returnUrlServiceProfilePage)}
      onSave={handleSubmit(onSave, (errors) => {
        Object.values(errors).forEach((error:any) => {
          toast.error(error.message || 'Verifique que los datos estén correctamente ingresados.')
          // setAlert(true, error.message || 'Verifique que los datos estén correctamente ingresados.', AlertSeverityEnum.error)
        })
        console.log({errors});
      })}
    >

      <CustomTextField
        label="Service Profile"
        name="service_profile"
        control={form.control}
        defaultValue={producto?.service_profile||form.getValues()?.service_profile}
        error={errors.service_profile}
        helperText={errors.service_profile?.message}
      // size={gridSizeMdLg6}
      />


    </SingleFormBoxScene>
  );
};

export default SaveServiceProfileComponent;
